import $ from 'jquery'

// Slick's built-in accessibility handler omits custom role buttons and textareas.
// Complement its documented lifecycle; never patch the vendor bundle or clones.
// Component options use finite, manually advanced sliders: jQuery's cloned DOM
// does not retain Vue's native event listeners. Keep that setting at breakpoints.
export function syncSlick (slider) {
    Array.prototype.forEach.call(slider.querySelectorAll('.slick-slide'), slide => {
        const hidden = slide.getAttribute('aria-hidden') === 'true'
        Array.prototype.forEach.call(slide.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'), control => {
            if (hidden) {
                if (control.tabIndex >= 0 && !control._toneSlideTab) {
                    control._toneSlideTab = { value: control.getAttribute('tabindex') }
                }
                control.setAttribute('tabindex', '-1')
            } else if (control._toneSlideTab) {
                if (control._toneSlideTab.value === null) control.removeAttribute('tabindex')
                else control.setAttribute('tabindex', control._toneSlideTab.value)
                delete control._toneSlideTab
            }
        })
        if (hidden && slide.contains(document.activeElement)) {
            const arrow = slider.querySelector('.slick-next:not(.slick-disabled), .slick-prev:not(.slick-disabled)')
            if (arrow) arrow.focus()
        }
    })
}

export function installSlickAccessibility () {
    $(document).off('.toneAccessibility').on('init.toneAccessibility reInit.toneAccessibility afterChange.toneAccessibility', '.slick-slider', function () {
        syncSlick(this)
    })
}



// WEBPACK FOOTER //
// ./src/accessibility/slick.js